import {  INCIDENT_DEATAILS_LABELS, PAGE_INDICES } from '../../../actions/allsureHomeClaim/types';
import {
    navigateToCategoryPage,
    navigateToBasicDetails,
    navigateToIncidentDetails,
    navigateToConfirmation,
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToUploadDocuments,
    transitionScrolling,
    navigateToSuccessPage,
} from '../../../actions/allsureHomeClaim/routing';

import { getActivePageIndex } from '../../../selectors/allsureHomeClaim/routing';
import { FIELD_STATUS } from '../../../reducers/status';

import { getUploadDocumentForm } from '../../../selectors/allsureHomeClaim/uploadDocuments';
import {  setBasicDetailsFieldValue } from '../../../actions/allsureHomeClaim/basicDetails';
import { getBasicDetailsForm } from '../../../selectors/allsureHomeClaim/basicDetails';
import { getIncidentDetailsForm } from '../../../selectors/allsureHomeClaim/incidentDetails';
import {  setAhocIncidentDetailsValue } from '../../../actions/allsureHomeClaim/incidentDetails';
import { setAhocDocumentValue } from '../../../actions/allsureHomeClaim/uploadDocuments';
import { submitPolicy, uploadDocumentsRequest } from '../../../actions/allsureHomeClaim/policyRequest';



export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) {
        return next(action);
    }

    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }

    onNavigatePrevious(store, state, activePageIndex);

    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    const uploadDocumentsFormFields = getUploadDocumentForm(state);
    const uploadDocumentsKeys=Object.keys(uploadDocumentsFormFields)
    const basicDetailsFormFields=getBasicDetailsForm(state)
    const incidentDetailsForm=getIncidentDetailsForm(state)
    const incidentDetailsFormFields=Object.keys(INCIDENT_DEATAILS_LABELS)
    const categoryPageFields=['privacyNotice']
    const basicDetailsFields=['policyNumber','fullName','mobileNumber','email']
    const confirmationPageFields=['tnc','consentNotice']
    switch (activePageIndex) {
        case PAGE_INDICES.CATEGORY:
            validateFormDetails(store, basicDetailsFormFields, categoryPageFields, setBasicDetailsFieldValue) &&
            store.dispatch(navigateToBasicDetails());
            break;

        case PAGE_INDICES.BASIC_DETAILS:
            validateFormDetails(store, basicDetailsFormFields, basicDetailsFields , setBasicDetailsFieldValue) && 
            store.dispatch(navigateToIncidentDetails());
            break;

        case PAGE_INDICES.INCIDENT_DEATAILS:
           validateFormDetails(store, incidentDetailsForm, incidentDetailsFormFields, setAhocIncidentDetailsValue) &&
            store.dispatch(navigateToUploadDocuments());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            validateFormDetails(store, uploadDocumentsFormFields, uploadDocumentsKeys, setAhocDocumentValue) &&
            store.dispatch(navigateToConfirmation());
            break;

        case PAGE_INDICES.CONFIRMATION:
            validateFormDetails(store, basicDetailsFormFields, confirmationPageFields, setBasicDetailsFieldValue) &&
            store.dispatch(uploadDocumentsRequest());
            break;

        case PAGE_INDICES.SUCCESS:
            break;
    }
};


const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.CATEGORY:
            break;

        case PAGE_INDICES.BASIC_DETAILS:
            store.dispatch(navigateToCategoryPage());
            break;

        case PAGE_INDICES.INCIDENT_DEATAILS:
            store.dispatch(navigateToBasicDetails());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(navigateToIncidentDetails());
            break;
            
        case PAGE_INDICES.CONFIRMATION:
            store.dispatch(navigateToUploadDocuments());
            break;

        case PAGE_INDICES.SUCCESS:
            store.dispatch(navigateToConfirmation());
            break;
    }
};


const validateFormDetails = (store, formFields, validationFieldKeys, validatorAction) => {
    const validate = (fieldValue, fieldType) => {
        const { status, value=null, displayValue=null ,fileName=null,fileContaint=null,file=null} = fieldValue[fieldType];
        return status !== FIELD_STATUS.VALID
            ? store.dispatch(
                 validatorAction({ fileName, fileContaint, file, inputType:fieldType, fieldType,
                    value,
                    displayValue, })
              )
            : [];
    };
    const inValidFields = validationFieldKeys?.flatMap((field) => {
        const dependentField = formFields[formFields[field]?.dependentField];
        const dependentValue = formFields[field]?.dependentValue;
        const defaultValidationCondition=(dependentValue,actualValue)=> dependentValue === actualValue.value
        const validationCondition=formFields[field].validationCondition ?? defaultValidationCondition
        if (dependentField) {
            return validationCondition(dependentValue,dependentField) ? validate(formFields, field) : [];
        } else {
            return validate(formFields, field);
        }
    });
    store.dispatch(transitionScrolling.scrollToId(inValidFields[0]?.value?.fieldType))
    return !inValidFields.length;
};
